import { isSafeRedirectPath } from './safe-redirect-path'

// Trimmed: dev's REACT_APP_WEB_HOST ends in a slash.
const WEB_HOST = (process.env.REACT_APP_WEB_HOST || '').replace(/\/+$/, '')

export const brandUrl = (path) => `${WEB_HOST}${path}`

/**
 * Brand's login, returning to `returnTo` once signed in. Studio's own `/login`
 * is for local testing only, so every visitor-facing sign-in goes through here.
 *
 * `signOut` makes brand show its login card even when it holds a session.
 * Without it brand mints a code straight back to Studio, which loops when the
 * Studio side keeps failing.
 */
export const brandLoginUrl = (returnTo, { signOut = false } = {}) => {
  const query = [
    signOut && 'signout=1',
    isSafeRedirectPath(returnTo) && `utm=${encodeURIComponent(returnTo)}`
  ].filter(Boolean).join('&')
  return brandUrl(`/login${query ? `?${query}` : ''}`)
}

export const goToBrandLogin = (returnTo, options) => {
  window.location.assign(brandLoginUrl(returnTo, options))
}
